















import Vue from 'vue'
export default Vue.extend({
  name: 'Alphabet',
  data: (): { letters: any } => ({
    letters: [...Array(26).keys()].map(num => String.fromCharCode(65 + num))
  }),
  computed: {
    wrongLetters () {
      return this.$store.state.wrongLetters
    }
  },
  methods: {
    letterClick (value: string): void {
      this.$store.commit('setState', { property: 'clickedLetter', value })
      this.$store.commit('incrementClick')
    }
  }
})
